export default __webpack_public_path__ + "static/media/2018-2.40fd3ebd.jpg";